<script>
import { required } from 'vuelidate/lib/validators'
import WorldMapAlarms from './world_map_alarms.vue'

// import appConfig from '@src/app.config'

import axios from 'axios'

export default {
	components: {
			WorldMapAlarms
	},
	props: {
		url: {
			type: String,
			default: '/office365/alarms/list?',
		}
	},
	data() {
		return {
			appConfig: {},
			category: 'List',
			items: [
				{
					text: 'Home',
					href: '/',
				},
				{
					text: 'Office 365 Alarms',
					active: true,
				},
			],
			appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
			alarm: {},
			events: [],
			locations: [],
			tableData: [],
			totalRows: 0,
			currentPage: 1,
			perPage: 10,
			pageOptions: [10, 25, 50, 100],
			filter: '',
			// filterOn: [],
			sortBy: 'CreationTime',
			sortDesc: true,
			fields: [
				{ key: 'severity', label: 'Severity', sortable: true },
				{ key: 'type', label: 'Type', sortable: true },
				{ key: 'target', label: 'Target', sortable: true },
		    { key: 'message', label: 'Alarm', sortable: true },
				{ key: 'start', label: 'Range Start', sortable: true },
				{ key: 'end', label: 'Range End', sortable: true },
				{ key: 'action', label: 'Action', sortable: false },
			],
			isBusy: true
		}
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	computed: {
		rows() {
			return this.totalRows || 0
		},
	},
	mounted () {
		this.loadData()
	},
  filters: {
    pretty: function(value) {
      return JSON.stringify(JSON.parse(value), null, 2);
    }
  },
	methods: {
		loadData (src='') {
			let that = this
			that.isBusy = true
			let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
			const countURL =  (src.length < 1) ? `${baseURL}${that.url}&count=yes` : `${baseURL}${that.url}&rawsearch=${src}&count=yes`

			axios.get(countURL)
			.then((response) => {
				that.totalRows = parseInt(response.data)
			})
			.catch(function (error) {
				return
			}) 
			const dataURL = (src.length < 1 ) ? 
				`${baseURL}${that.url}&page=${that.currentPage}&page_size=${that.perPage}` :
				`${baseURL}${that.url}&page=${that.currentPage}&page_size=${that.perPage}&rawsearch=${src}`
			axios.get(dataURL).then((response) => {
				if (response.status === 200) {
          console.log(response.data)
					that.tableData = response.data.map(function(entry){
						return {
              id: entry["_id"],
							type: entry.type || "",
							message: entry.message || "",
							severity: entry.severity || "",
							target: entry.target || "",
							start: new Date(entry.start['$date']).toLocaleString() || '',
							end: new Date(entry.end['$date']).toLocaleString() || '',
							events: entry.raw_events || [],
							locations: entry.locations || [],
						}
          })
        }
        console.log(that.tableData)

				that.isBusy = false
			})
			.catch(function (error) {

			}) 
		},
    modalIncidentDetailOk() {
			this.alarm = {}
			this.events = []
			this.locations = []
    },
		showDetails (data) {
			if (data === undefined) return
			console.log(data)
			this.alarm.id = data.item.id
			this.alarm.target = data.item.target
			this.alarm.type = data.item.type
			this.alarm.message = data.item.message
			this.alarm.severity = data.item.severity

			this.events = data.item.events
			this.locations = data.item.locations
			this.$refs['modal-details'].show()
		},
		doSearch() {
			let filter = this.filter
			if (filter.length !== undefined) {
				this.loadData(filter)
			}
		}
	},
	watch: {
		currentPage: {
			handler: function(value) {
				this.loadData(this.filter)
			}
		},
		perPage: {
			handler: function(value) {
				this.loadData(this.filter)
			}
		},
	}
}
</script>

<template>
	<div>
		<div class="row mb-md-2">
			<div class="col-sm-6 col-md-6">
				<span>
					Alarms found: 
					<b>
						{{ rows }}
					</b>
					at
					<b>
						{{ new Date().toLocaleString() }}
					</b>
				</span>
			</div>

			<div class="col-sm-6 col-md-6">
				<div
					id="tickets-table_filter"
					class="dataTables_filter text-md-right"
				>
					<label class="d-inline-flex align-items-center">
						<b-form-input
							v-model="filter"
							type="search"
							placeholder="Text to search..."
							class="form-control form-control-sm ml-2"
						></b-form-input>
						<b-button size="sm" variant="light" @click="doSearch">
							Search
						</b-button>
					</label>
				</div>
			</div>
		</div>
		<div class="table-responsive mb-0">
			<b-table
				:items="tableData"
				:fields="fields"
				:busy="isBusy"
				responsive="sm"
				:per-page="0"
				:current-page="currentPage"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				:totalRows="totalRows"
				:pagination-options="{
					enabled: true
				}"
			>
				<template v-slot:table-busy>
					<div class="text-center">
					<br><br>
					<b-spinner class="align-middle"></b-spinner>
					<strong>&nbsp;&nbsp;Loading...</strong>
					</div>
				</template>
				<template v-slot:cell(severity)="data">
					<template v-if="data.item.severity === 'low'">
						<feather type="alert-circle" class="icon-xs icon-dual-success"></feather>
					</template>
					<template v-else-if="data.item.severity === 'medium'">
						<feather type="alert-triangle" class="icon-xs icon-dual-warning"></feather>
					</template>
					<template v-else>
						<feather type="alert-octagon" class="icon-xs icon-dual-danger"></feather>
					</template>
				</template>
				<template v-slot:cell(creation_time)="data">
					{{ data.item.creation_time }}
				</template>
				<template v-slot:cell(action)="data">
					<b-dropdown right variant="white" class="align-self-center" toggle-class="p-0">
						<template v-slot:button-content>
							<feather type="chevron-down" class="align-middle" style="height:12px !important;width:20px !important;"></feather>
						</template>
						<b-dropdown-item @click="showDetails(data)" class="notify-item">
							<feather
								type="search"
								class="icon-dual icon-xs mr-2 align-middle"
							></feather>
							<span>Details</span>
						</b-dropdown-item>
					</b-dropdown>
				</template>
			</b-table>
		</div>
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<div id="tickets-table_length" class="dataTables_length">
					<label class="d-inline-flex align-items-center">
						Show&nbsp;
						<b-form-select
							v-model="perPage"
							size="sm"
							:options="pageOptions"
						></b-form-select
						>&nbsp;entries
					</label>
				</div>
			</div>
			<div class="col">
				<div
					class="dataTables_paginate paging_simple_numbers float-right"
				>
					<ul class="pagination pagination-rounded mb-0">
						<b-pagination
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
						></b-pagination>
					</ul>
				</div>
			</div>
		</div>
		<b-modal
			ref="modal-details"
			id="incident.incident_id"
			size="xl"
			title="Alarm Details"
			:centered=true
			:no-fade=true
      @ok="modalIncidentDetailOk"
			no-close-on-backdrop
			no-close-on-esc
			hide-header-close
			ok-only>
			<div>
				<span><span class="varname">Target:&nbsp;</span><span class="varcontent">{{ alarm.target }}</span></span>
			</div>
			<div>
				<span><span class="varname">Type:&nbsp;</span><span class="varcontent">{{ alarm.type }}</span></span>
			</div>
			<div>
				<span><span class="varname">Severity:&nbsp;</span>
					<template v-if="alarm.severity==='high'">
						<span class="varcontent" :class="'severity-'+alarm.severity">{{ alarm.severity }}</span>
					</template>
					<template v-else-if="alarm.severity==='medium'">
						<span class="varcontent" :class="'severity-'+alarm.severity">{{ alarm.severity }}</span>
					</template>
					<template v-else-if="alarm.severity==='low'">
						<span class="varcontent" :class="'severity-'+alarm.severity">{{ alarm.severity }}</span>
					</template>
				</span>
			</div>
			<div>
				<span><span class="varname">Message:&nbsp;</span><span class="varcontent">{{ alarm.message }}</span></span>
			</div>
			<div role="tablist" class="custom-accordionwitharrow">
				<template v-if="locations !== undefined && locations.length > 0">
					<a href="#" class="text-dark" v-b-toggle.collapse-assets>
						<h5 class="mb-0">
							<feather type="chevron-down" class="align-middle"></feather>
							Locations
							<span class="text-muted font-size-14">({{ locations.length }})</span>
						</h5>
					</a>
					<b-collapse visible id="collapse-assets">
						<div style="align:center">
							<table style="width:100%">
								<tr>
									<td style="width: 50%">
										<ul>
											<li v-for="loc in locations">
												{{ loc.country }},
												{{ loc.city}}
											</li>
										</ul>
									</td>
									<td style="padding-right:30px;">
										<WorldMapAlarms 
												:locations = "locations"
										/>
									</td>
								</tr>
							</table>
						</div>
					</b-collapse>
				</template>

				<template v-if="events !== undefined">
					<a href="#" class="text-dark" v-b-toggle.collapse-assets>
						<h5 class="mb-0">
							<feather type="chevron-down" class="align-middle"></feather>
							Events
							<span class="text-muted font-size-14">({{ events.length }})</span>
						</h5>
					</a>
					<b-collapse visible id="collapse-assets">
						<!-- <template v-if="events.length === 1 && events[0].intelligence === undefined">
							<pre>
								{{ events[0] }}
							</pre>
						</template> -->
						<template v-if="alarm.type === 'Business Email Compromise'">
							<pre>
								{{ events }}
							</pre>
						</template>
						<template v-else>
							<table width="100%" style="border:1px;" >
								<thead>
									<th>Date / Time</th>
									<th>Operation</th>
									<th>Result Status</th>
									<th>Client IP</th>
									<th>Country</th>
									<th>City</th>
									<th>ASN</th>
									<th>ISP</th>
								</thead>
								<tbody>
									<tr v-for="event, index in events" v-bind:key="index">
										<td>{{ new Date(event.CreationTime['$date']).toLocaleString() }}</td>
										<template v-if="event.intelligence !== undefined && event.intelligence.geoip !== undefined">
											<td>{{ event.Operation || 'N.A.' }}</td>
											<td>{{ event.ResultStatus || 'N.A.' }}</td>
											<td>
												<template v-if="event.intelligence.geoip.security.threat_level==='high'">
													<span :class="'severity-'+event.intelligence.geoip.security.threat_level">{{ event.ClientIP }}</span>
												</template>
												<template v-else-if="event.intelligence.geoip.security.threat_level==='medium'">
													<span :class="'severity-'+event.intelligence.geoip.security.threat_level">{{ event.ClientIP }}</span>
												</template>
												<template v-else-if="event.intelligence.geoip.security.threat_level==='low'">
													<span :class="'severity-'+event.intelligence.geoip.security.threat_level">{{ event.ClientIP }}</span>
												</template>										
											<td>{{ event.intelligence.geoip.location.country_flag_emoji || ''}} {{ event.intelligence.geoip.country_name || 'N.A.' }}</td>
											<td>{{ event.intelligence.geoip.city || 'N.A.' }}</td>
											<template v-if="event.intelligence.geoip.connection !== undefined">
											<td>{{ event.intelligence.geoip.connection.asn || 'N.A.' }}</td>
											<td>{{ event.intelligence.geoip.connection.isp || 'N.A.' }}</td>
											</template>
										</template>
										<!-- <template v-else>
											<td colspan="7">
												<pre>
													{{ event }}
												</pre>
											</td>
										</template>						 -->
									</tr>
								</tbody>
							</table>
						</template>
						<!-- <pre>
						{{ events || pretty }}
						</pre> -->
					</b-collapse>
				</template>
			</div>
		</b-modal>
	</div>
</template>

<style>
	.incident-status {
		width: 15%;
	}
	.incident-description {
		width: 35%;
	}
	.varname {
		font-size:1.2em;
		font-weight: 700;
	}
	.varcontent {
		font-size:1.2em;
		font-weight: 200;
	}
	.severity-high {
    color: #DC001E;
	}
	.severity-medium {
    color: #FECA00;
	}
	.severity-low {
    color: #01AD00;
	}
</style>